/**
 * Menu du compte — carré d'accent avec les initiales, nom affiché, chevron, déroulant
 * (coquille.md §6.1). Dernier élément de la barre, toujours.
 *
 * Contenu, dans l'ordre : Mon compte · séparateur · Langue (choix unique) · séparateur ·
 * Déconnexion en `MENU_ITEM_ACCENT` (@exidis/ui 1.8.0 — `text-accent-ink` ajouté à
 * `MENU_ITEM` était écrasé par son `text-ink`).
 * La langue vit ICI une fois connecté — pas dans la barre.
 * « Mon compte » ouvre la destination à onglets `/compte` (Profil, Préférences, Clés API,
 * Aide MCP) — Profil et Préférences ont cessé d'être deux entrées séparées du menu
 * (§ audit exiUI 2026-09-27).
 *
 * Une photo, si le compte en a une, remplace les initiales DANS LE MÊME CARRÉ. Le carré est
 * en `bg-accent` + `text-on-accent`, jamais un blanc en dur : sur l'ambre et le cyan du
 * studio, le blanc tombe sous 3:1.
 */

import { NavLink } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import { initiales, nomAffiche } from '../../lib/identite.js';
import {
  ACCOUNT_NAME,
  ACCOUNT_SQUARE,
  ACCOUNT_TRIGGER,
  MENU_GROUP,
  MENU_ITEM,
  MENU_ITEM_ACCENT,
  MENU_SEP,
} from '../../ui/theme.js';

import { ChoixLangue } from './ChoixLangue.jsx';
import { Chevron, Deroulant } from './Deroulant.jsx';

export default function MenuCompte({ user, onLogout }) {
  const { t } = useTranslation();
  const nom = nomAffiche(user);

  return (
    <Deroulant
      label={t('account.menu', { name: nom })}
      declencheur={({ ouvert }) => (
        <span className={ACCOUNT_TRIGGER}>
          <span className={ACCOUNT_SQUARE} aria-hidden="true">
            {user?.avatarUrl ? (
              <img src={user.avatarUrl} alt="" className="h-6 w-6 object-cover" />
            ) : (
              initiales(nom)
            )}
          </span>
          <span className={ACCOUNT_NAME}>{nom}</span>
          <Chevron ouvert={ouvert} />
        </span>
      )}
    >
      <NavLink to="/compte?onglet=profil" role="menuitem" className={MENU_ITEM}>
        {t('nav.account')}
      </NavLink>

      <div className={MENU_SEP} role="separator" />
      <p className={MENU_GROUP}>{t('account.language')}</p>
      <ChoixLangue persist />

      <div className={MENU_SEP} role="separator" />
      <button type="button" role="menuitem" className={MENU_ITEM_ACCENT} onClick={onLogout}>
        {t('nav.logout')}
      </button>
    </Deroulant>
  );
}
